import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/expediente/getIngresosTotalesExpediente.php';

export default function getIngresosTotalesExpediente({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}